import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}
// function loadComponent(dir , component) {
//     return () => import(/* webpackChunkName: "view-[request]" */ `@/${dir}/${component}.vue`);
// }

export default new Router({
  // mode: process.env.NODE_ENV == 'development' ? 'hash' : 'history',
  mode: "history",
  base: process.env.BASE_URL,
  data: function() {},
  routes: [
    {
      path: "/404",
      name: "404",
      redirect: "/",
    },
    {
      path: "/NotSupport",
      name: "notSupport",
      component: loadView("NotSupport"),
    },
    {
      path: "*",
      redirect: "404",
    },
    {
      path: "/",
      name: "home",
      component: loadView("Home"),
      children: [
        {
          path: "/level/:level_id",
          name: "level",
          component: loadView("Home"),
        },
        {
          path: "/login/:login_flag",
          name: "login",
          component: loadView("Home"),
        },
      ],
      props: true, // Pass route.params to props
    },
    {
      path: "/about",
      name: "about",
      component: loadView("About"),
      props: true, // Pass route.params to props
    },
    {
      path: "/faq",
      name: "faq",
      component: loadView("FAQ"),
      props: true, // Pass route.params to props
    },
    {
      path: "/program/:role",
      name: "program",
      component: loadView("Program"),
      meta: { requiresAuth: true },
      children: [
        {
          path: "/program/:role/:program",
          name: "start",
          meta: { requiresAuth: true },
        },
        {
          path: "/program/:role/:program/:step",
          name: "step",
          meta: { requiresAuth: true },
        },
        {
          path: "/program/:role/:program/:step/:item",
          name: "item",
          meta: { requiresAuth: true },
        },
      ],
    },
    {
      path: "/PACES",
      alias: "/paces",
      name: "paces_registration",
      redirect: "/register/paces",
    },
    {
      path: "/SPIRITAF",
      alias: "/spiritaf",
      name: "spiritaf_registration",
      redirect: "/register/spiritaf",
    },
    {
      path: "/INSIGHT",
      alias: "/insight",
      name: "insight_registration",
      redirect: "/register/insight",
    },
    {
      path: "/CIMPACTBD",
      alias: "/cimpactbd",
      name: "cimpactbd_registration",
      redirect: "/register/cimpactbd",
    },
    {
      path: "/OLIGO",
      alias: "/oligo",
      name: "oligo_registration",
      redirect: "/register/oligo",
    },
    {
      path: "/AIM",
      alias: "/aim",
      name: "aim_campaign",
      redirect: "/campaign/aim",
    },
    {
      path: "/PWC",
      alias: ["/pwc", "/ProtectWhatCounts"],
      name: "pwc_registration",
      redirect: "/register/pwc",
    },
    {
      path: "/ARC",
      alias: "/arc",
      name: "arc_registration",
      redirect: "/register/arc",
    },
    {
      path: "/SDMUC",
      alias: "/sdmuc",
      name: "sdmuc_registration",
      redirect: "/register/sdmuc",
    },
    {
      path: "/HFREFLECT",
      alias: "/hfreflect",
      name: "hfreflect_registration",
      redirect: "/register/hfreflect",
    },
    {
      path: "/ARCTIC",
      alias: "/arctic",
      name: "arctic_registration",
      redirect: "/register/arctic",
    },
    {
      path: "/NASS",
      alias: "/nass",
      name: "nass_registration",
      redirect: "/register/nass",
    },
    {
      path: "/STRIVE",
      alias: "/strive",
      name: "strive_registration",
      redirect: "/register/strive",
    },
    {
      path: "/DNA",
      alias: "/dna",
      name: "dna_registration",
      redirect: "/register/dna",
    },
    {
      path: "/COPD",
      alias: "/copd",
      name: "copd_registration",
      redirect: "/register/copd"
    },
    {
      path: "/ADHDMEDED",
      alias: "/adhdmeded",
      name: "adhdmeded_registration",
      redirect: "/register/adhdmeded"
    },
    {
      path: "/NSCLC",
      alias: "/nsclc",
      name: "nsclc_registration",
      redirect: "/register/nsclc"
    },
    {
      path: "/ECHO",
      alias: "/echo",
      name: "echo_registration",
      redirect: "/register/echo"
    },
    {
      path: "/CHARIOT",
      alias: "/chariot",
      name: "chariot_study_registration",
      redirect: "/register/chariot"
    },
    {
      path: "/ABOUTTYME",
      alias: "/abouttyme",
      name: "about_tyme_registration",
      redirect: "/register/abouttyme"
    },
    {
      path: "/CLLPULSE",
      alias: "/cllpulse",
      name: "cllpulse_registration",
      redirect: "/register/cllpulse"
    },
    {
      path: "/PACE/:registrationHashCode",
      alias: "/pace/:registrationHashCode",
      name: "pace_registration",
      redirect: "/register/pace/:registrationHashCode",
    },    
    {
      path: "/SPINSIGHT",
      alias: "/spinsight",
      name: "spinsight_registration",
      redirect: "/register/spinsight"
    },
    {
        path: "/register",
        name: "register",
        component: loadView("Register"),
        children: [
            {
                path: "",
                redirect: "/",
                meta: {
                   restrictedRegistrantsList: false,
                   hashCodeVerificationRequired: false,
                },
            },
            {
                name: "nnaRegisterProgram",
                path: "nna",
                redirect: () => {
                  window.location.href = "https://nna.vivomap.ca/register";
                },
                meta: {
                   restrictedRegistrantsList: false,
                   hashCodeVerificationRequired: false,
                },                
            },
            {
                name: "registerProgram",
                path: "/register/:program",
                meta: {
                   restrictedRegistrantsList: false,
                   hashCodeVerificationRequired: false,
                },
            },
            {
                name: "registerToExclusiveProgram",
                path: "/register/:program/:registrationHashCode",
                meta: {
                   restrictedRegistrantsList: true,
                   hashCodeVerificationRequired: true,
                },
            },
        ],
        meta: {
           restrictedRegistrantsList: false,
           hashCodeVerificationRequired: false,
        },
        props: true,
    },
    {
      path: "/rep",
      name: "rep",
      component: loadView("RepHome"),
    },
    {
      path: "/account_validation/:uid/:code",
      name: "account_validation",
      component: loadView("AccountValidation"),
      props: true, // Pass route.params to props
    },

    {
      path: "/admin",
      name: "admin",
      component: loadView("Admin"),
      meta: { requiresAuth: true },
      props: true,
      children: [
        {
          path: "/admin/:category/:program_id/:action",
          name: "adminWithAction",
          meta: { requiresAuth: true },
          component: loadView("Admin"),
          props: true,
        },
      ],
    },

    {
      path: "/datadump",
      name: "dataDump",
      component: loadView("DataDump"),
      meta: { requiresAuth: true },
      props: true,
    },
    {
      path: "/NNA",
      alias: "/nna",
      name: "nna_registration",
      redirect: () => {
        window.location.href = "https://nna.vivomap.ca/register";
      },
    },
    {
      path: "/campaign/:path",
      name: "Campaign",
      component: loadView("Campaign"),
      //component: () => import(/* webpackChunkName: "campaign" */ '@/views/Campaign.vue'),
      props: true,
    },
  ],
});
